import { useData } from '../context/DataContext.js';

const AnimatedLogoCloud = () => {
  const { partners } = useData();
  
  // Filter active partners with logos
  const activePartners = partners?.filter(partner => 
    partner.isPaid === 1 && partner.PartnerLogo && partner.PartnerWebsiteLink
  ) || [];

  // Static display only on desktop (sm and up) with 3 or fewer partners
  const isStatic = activePartners.length <= 3;

  return (
    <div className="w-full h-full max-w-full absolute inset-0" style={{ overflow: 'hidden' }}>
      {/* Mobile: Always scroll */}
      <div className="sm:hidden h-full w-full" style={{ overflow: 'hidden', position: 'relative' }}>
        <div className="mx-auto w-full px-1 max-w-full h-full" style={{ overflow: 'hidden' }}>
          <div
            className="group relative flex justify-center items-center gap-6 p-1 w-full h-full"
            style={{
              maskImage: 'linear-gradient(to left, transparent 0%, black 20%, black 80%, transparent 95%)',
              overflow: 'hidden',
              width: '100%',
              maxWidth: '100%',
            }}
          >
            <div className="flex shrink-0 animate-logo-cloud flex-row justify-around gap-6 h-full items-center">
              {activePartners.map((partner, key) => (
                <a
                  key={key}
                  href={partner.PartnerWebsiteLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center h-full"
                >
                  <img
                    src={partner.PartnerLogo}
                    className="h-8 max-h-full w-auto object-contain px-2"
                    alt={`${partner.PartnerName}`}
                  />
                </a>
              ))}
              {activePartners.map((partner, key) => (
                <a
                  key={`duplicate-${key}`}
                  href={partner.PartnerWebsiteLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center h-full"
                >
                  <img
                    src={partner.PartnerLogo}
                    className="h-8 max-h-full w-auto object-contain px-2"
                    alt={`${partner.PartnerName}`}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Desktop: Static if 3 or fewer, scroll if more */}
      <div className="hidden sm:block py-2 max-w-full overflow-x-hidden">
        {isStatic ? (
          <div className="flex justify-center items-center gap-10 flex-wrap max-w-full">
            {activePartners.map((partner, key) => (
              <a
                key={key}
                href={partner.PartnerWebsiteLink}
                target="_blank"
                rel="noopener noreferrer"
                className="shrink-0"
              >
                <img
                  src={partner.PartnerLogo}
                  className="h-12 px-5 max-w-full object-contain"
                  alt={`${partner.PartnerName}`}
                />
              </a>
            ))}
          </div>
        ) : (
          <div className="mx-auto w-full px-1 h-full max-w-full overflow-x-hidden">
            <div
              className="group relative flex gap-6 overflow-hidden py-2 max-w-full"
              style={{
                maskImage:
                  'linear-gradient(to left, transparent 0%, black 20%, black 80%, transparent 95%)',
              }}
            >
              <div className="flex shrink-0 animate-logo-cloud flex-row justify-around gap-10">
                {activePartners.map((partner, key) => (
                  <a
                    key={key}
                    href={partner.PartnerWebsiteLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={partner.PartnerLogo}
                      className="h-12 px-5"
                      alt={`${partner.PartnerName}`}
                    />
                  </a>
                ))}
                {activePartners.map((partner, key) => (
                  <a
                    key={`duplicate-${key}`}
                    href={partner.PartnerWebsiteLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={partner.PartnerLogo}
                      className="h-12 px-5"
                      alt={`${partner.PartnerName}`}
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AnimatedLogoCloud; 